exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clinic-verifactu h2{font-weight:700;font-size:24px}", ""]);

// exports
